import { useEffect, useState } from "react";
import { useLatestReleaseNotes } from "./useLatestReleaseNotes";
import { ReleaseNotesData } from "../types/releaseNotes";
import { useReleaseVersion } from "../stores/relaseVersion";

const useNewReleaseAvailable = () => {
  const [hasLatestReleaseNotes, setHasLatestReleaseNotes] = useState(false);

  const {version, updateReleaseVersion} = useReleaseVersion()

  const { data: latestRelease, dataUpdatedAt } = useLatestReleaseNotes<ReleaseNotesData>({
    params: {
      refetchInterval: 1000 * 60 * 10
    }
  })

  useEffect(() => {
    if(!latestRelease?.version) return

    if(!version) updateReleaseVersion(latestRelease?.version)

    if(version && version !== latestRelease?.version) {
      setHasLatestReleaseNotes(true)
    }
  }, [dataUpdatedAt, version]);

  return {
    hasNewReleaseNote: hasLatestReleaseNotes,
  };
};

export default useNewReleaseAvailable;
